var _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOpenLoyaltyIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 196,
    height: 30,
    viewBox: "0 0 196 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "636a316e243b2412c90c11f9_Open Loyalty logo 1",
    clipPath: "url(#clip0_8725_7201)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8725_7201",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 196,
    height: 30
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clip0_7972_31075"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M195.437 0H0V30H195.437V0Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8725_7201)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    opacity: 0.8,
    d: "M26.2238 14.4366C26.2238 22.4489 17.0571 27.0423 13.1133 30V21.7606L14.2261 20.7953L14.2564 20.7689C18.1917 17.3352 20.7877 15.0702 20.7877 12.2921C20.7877 10.0226 18.9305 8.23944 16.5668 8.23944C15.2314 8.23944 13.9499 8.83628 13.1133 9.77945V0L26.2238 5.77465V14.4366Z",
    fill: "#47388C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M0 5.77465L13.1105 0V9.77945C12.2739 8.83628 10.9924 8.23944 9.657 8.23944C7.29327 8.23944 5.43606 10.0226 5.43606 12.2921C5.43606 15.0751 8.04109 17.3431 11.988 20.7795L11.9977 20.7879L13.1105 21.7606V30C9.37987 27.4648 0 22.4489 0 14.4366V5.77465Z",
    fill: "#47388C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M41.0373 22.0043C39.5502 22.0043 38.2063 21.6865 37.0057 21.051C35.8187 20.4155 34.8842 19.5434 34.202 18.4347C33.5335 17.3124 33.1992 16.055 33.1992 14.6623C33.1992 13.2696 33.5335 12.0189 34.202 10.9102C34.8842 9.78792 35.8187 8.90905 37.0057 8.27355C38.2063 7.63806 39.5502 7.32031 41.0373 7.32031C42.5245 7.32031 43.8616 7.63806 45.0485 8.27355C46.2355 8.90905 47.1701 9.78792 47.8523 10.9102C48.5344 12.0189 48.8755 13.2696 48.8755 14.6623C48.8755 16.055 48.5344 17.3124 47.8523 18.4347C47.1701 19.5434 46.2355 20.4155 45.0485 21.051C43.8616 21.6865 42.5245 22.0043 41.0373 22.0043ZM41.0373 19.2054C41.8832 19.2054 42.6472 19.0161 43.3295 18.6375C44.0116 18.2454 44.5437 17.7046 44.9257 17.015C45.3214 16.3254 45.5192 15.5412 45.5192 14.6623C45.5192 13.7834 45.3214 12.9992 44.9257 12.3096C44.5437 11.62 44.0116 11.086 43.3295 10.7074C42.6472 10.3153 41.8832 10.1192 41.0373 10.1192C40.1915 10.1192 39.4274 10.3153 38.7452 10.7074C38.0631 11.086 37.5242 11.62 37.1285 12.3096C36.7465 12.9992 36.5554 13.7834 36.5554 14.6623C36.5554 15.5412 36.7465 16.3254 37.1285 17.015C37.5242 17.7046 38.0631 18.2454 38.7452 18.6375C39.4274 19.0161 40.1915 19.2054 41.0373 19.2054Z",
    fill: "#30265D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M57.5682 7.5625C58.837 7.5625 59.9353 7.77207 60.863 8.19123C61.8044 8.61038 62.5275 9.20531 63.0324 9.97602C63.5371 10.7467 63.7896 11.6594 63.7896 12.7141C63.7896 13.7552 63.5371 14.6679 63.0324 15.4521C62.5275 16.2228 61.8044 16.8177 60.863 17.2369C59.9353 17.6425 58.837 17.8453 57.5682 17.8453H54.6825V21.7597H51.3672V7.5625H57.5682ZM57.3839 15.1681C58.3799 15.1681 59.1372 14.9586 59.6556 14.5394C60.174 14.1067 60.4333 13.4983 60.4333 12.7141C60.4333 11.9163 60.174 11.3079 59.6556 10.8887C59.1372 10.456 58.3799 10.2397 57.3839 10.2397H54.6825V15.1681H57.3839Z",
    fill: "#30265D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M77.2484 19.1231V21.7597H66.1562V7.5625H76.9824V10.1991H69.4511V13.2819H76.1024V15.8374H69.4511V19.1231H77.2484Z",
    fill: "#30265D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M93.0253 7.5625V21.7597H90.3035L83.1611 13.14V21.7597H79.8867V7.5625H82.629L89.7509 16.1822V7.5625H93.0253Z",
    fill: "#30265D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M102.211 7.5625H105.526V19.0825H112.709V21.7597H102.211V7.5625Z",
    fill: "#30265D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M121.26 22.0043C119.773 22.0043 118.429 21.6865 117.228 21.051C116.042 20.4155 115.108 19.5434 114.425 18.4347C113.757 17.3124 113.422 16.055 113.422 14.6623C113.422 13.2696 113.757 12.0189 114.425 10.9102C115.108 9.78792 116.042 8.90905 117.228 8.27355C118.429 7.63806 119.773 7.32031 121.26 7.32031C122.748 7.32031 124.085 7.63806 125.271 8.27355C126.459 8.90905 127.393 9.78792 128.076 10.9102C128.757 12.0189 129.099 13.2696 129.099 14.6623C129.099 16.055 128.757 17.3124 128.076 18.4347C127.393 19.5434 126.459 20.4155 125.271 21.051C124.085 21.6865 122.748 22.0043 121.26 22.0043ZM121.26 19.2054C122.106 19.2054 122.87 19.0161 123.553 18.6375C124.235 18.2454 124.767 17.7046 125.149 17.015C125.545 16.3254 125.742 15.5412 125.742 14.6623C125.742 13.7834 125.545 12.9992 125.149 12.3096C124.767 11.62 124.235 11.086 123.553 10.7074C122.87 10.3153 122.106 10.1192 121.26 10.1192C120.414 10.1192 119.651 10.3153 118.968 10.7074C118.287 11.086 117.748 11.62 117.352 12.3096C116.97 12.9992 116.778 13.7834 116.778 14.6623C116.778 15.5412 116.97 16.3254 117.352 17.015C117.748 17.7046 118.287 18.2454 118.968 18.6375C119.651 19.0161 120.414 19.2054 121.26 19.2054Z",
    fill: "#30265D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M137.846 16.7298V21.7597H134.531V16.6893L128.984 7.5625H132.504L136.332 13.8701L140.158 7.5625H143.413L137.846 16.7298Z",
    fill: "#30265D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M153.356 18.7174H146.704L145.436 21.7597H142.039L148.424 7.5625H151.699L158.104 21.7597H154.625L153.356 18.7174ZM152.312 16.2228L150.041 10.7873L147.769 16.2228H152.312Z",
    fill: "#30265D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M159.59 7.5625H162.905V19.0825H170.088V21.7597H159.59V7.5625Z",
    fill: "#30265D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M173.569 10.2397H168.984V7.5625H181.468L182.634 10.2397H176.884V21.7597H173.569V10.2397Z",
    fill: "#30265D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M189.87 16.7298V21.7597H186.554V16.6893L181.008 7.5625H184.528L188.355 13.8701L192.182 7.5625H195.436L189.87 16.7298Z",
    fill: "#30265D"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8725_7201"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 196,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenLoyaltyIcon);
export default __webpack_public_path__ + "static/media/openLoyaltyIcon.74617befc5b6185316e8cf40a6416b9e.svg";
export { ForwardRef as ReactComponent };